import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPage: 1,
  tableFilters: {},
  selectedBrand: "",
  selectedStore: "",
  storeFilterList: [],
  brandRawList: [],
  storeRawList: [],
  selectedStatus: "",
  startDate: null,
  endDate: null,
  startDateDisplay: null,
  endDateDisplay: null,
  selectedMonthYear: {},
};

const fileCenterSlice = createSlice({
  name: "fileCenter",
  initialState,
  reducers: {
    setSelectedPage: (state, action) => {
      state.selectedPage = action.payload;
    },
    setTableFilters: (state, action) => {
      state.tableFilters = action.payload;
    },
    setSelectedBrand: (state, action) => {
      state.selectedBrand = action.payload;
    },
    setSelectedStore: (state, action) => {
      state.selectedStore = action.payload;
    },
    setStoreFilterList: (state, action) => {
      state.storeFilterList = action.payload;
    },
    setBrandRawList: (state, action) => {
      state.brandRawList = action.payload;
    },
    setStoreRawList: (state, action) => {
      state.storeRawList = action.payload;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    setStartDateDisplay: (state, action) => {
      state.startDateDisplay = action.payload;
    },
    setEndDateDisplay: (state, action) => {
      state.endDateDisplay = action.payload;
    },
    setSelectedMonthYear: (state, action) => {
        state.selectedMonthYear = action.payload;
    }
  },
});

export const fileCenterActions = fileCenterSlice.actions;
export default fileCenterSlice;
